module.exports = __webpack_public_path__ + "ucfk.jpg?92ef94ce455a1504de98ab39255a0933";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ucfk.jpg
// module id = 98
// module chunks = 0